
export interface IValidateOwnershipNameRequest {
    userId: number;
    orgId: number;
    rateType: number;
    ownershipName: string;
}

export class ValidateOwnershipNameRequest implements IValidateOwnershipNameRequest {
    userId: number;
    orgId: number;
    rateType: number;
    ownershipName: string;
}
